import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Row, Col, FormGroup, Input, Label, Button, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem} from "reactstrap";
import FiltroStore from "../stores/FiltroStore";
import CustomDatePicker from "./CustomDatePicker";
import NumberFormat from "react-number-format";
import {MonthPicker} from "./MonthPicker";
import {Validacao} from "./Validacao";
import PropTypes from "prop-types";
import Select from "react-select";
import qs from "query-string";
import _ from "lodash";

@inject("store")
@observer
export class Filtro extends Component {
    static propTypes = {
        history: PropTypes.object,
        location: PropTypes.object,
        fields: PropTypes.array.isRequired,
        validations: PropTypes.array,
        onSubmit: PropTypes.func.isRequired,
        onExportExcel: PropTypes.func,
        onExportPdf: PropTypes.func,
        inicialDataValue: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.controller = new FiltroStore(this.props.inicialDataValue);

        this.validacaoStore = this.props.store.validacaoStore;
    }

    componentDidMount() {
        const params = qs.parse(this.props.location.search);

        this.controller.carregarListas(params, this.props.fields);

        if(_.isEmpty(params)) {
            this.controller.setAnoCorrente(this.props.fields);
        } else {
            this.props.onSubmit(this.controller.getFiltro());
        }
    }

    onSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if(!this.canSubmit()) {
            return;
        }

        if(this.props.history && this.props.location) {
            this.props.history.push({
                pathname: this.props.location.pathname,
                search: qs.stringify(_.pickBy(this.controller.filtro, _.identity))
            });
        }

        this.props.onSubmit(this.controller.getFiltro());
    }

    onExportExcel = () => {
        if(!this.canSubmit()) {
            return;
        }

        this.props.onExportExcel(this.controller.getFiltro());
    }

    onExportPdf = () => {
        if(!this.canSubmit()) {
            return;
        }

        this.props.onExportPdf(this.controller.getFiltro());
    }

    onClear = () => {
        this.controller.limparFiltro(this.props.fields);
        this.forceUpdate();
        if(this.props.controller) {
            this.props.controller.dados = "";
            this.props.controller.erro = null
            this.props.store.formStore.setSubmitted(false);
            this.props.store.formStore.setSubmitMensagemErro("");
        }
    }

    canSubmit = () => {
        this.props.store.formStore.setSubmitted(true);
        this.props.store.formStore.setSubmitMensagemErro("");

        return this.props.store.validacaoStore.isValidForm;
    }

    render() {
        return (
            <div className="filter-container">
                <form onSubmit={(event) => this.onSubmit(event)} className="filter-box">
                    <Row>
                        { _.includes(this.props.fields, "AREA") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="areas">N1</Label>
                                    <Select id="areas"
                                            value={this.controller.filtro.areas}
                                            onChange={(value) => this.controller.setAreas(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Todas"
                                            multi={true}
                                            options={[ ...this.controller.areas ]} />
                                    { _.includes(this.props.validations, "AREA_OBRIGATORIA") &&
                                        <Validacao id="areasObrigatorias" valor={this.controller.areasValidacao}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "CENTRAL") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="centrais">N2</Label>
                                    <Select id="centrais"
                                            value={this.controller.filtro.centrais}
                                            onChange={(value) => this.controller.setCentrais(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Todas"
                                            multi={true}
                                            options={[ ...this.controller.centrais ]} />
                                    { _.includes(this.props.validations, "CENTRAL_OBRIGATORIA") &&
                                        <Validacao id="centraisObrigatorias" valor={this.controller.centraisValidacao}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "DIVISAO") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="divisoes">N3</Label>
                                    <Select id="divisoes"
                                            value={this.controller.filtro.divisoes}
                                            onChange={(value) => this.controller.setDivisoes(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Todas"
                                            multi={true}
                                            options={[ ...this.controller.divisoes ]} />
                                    { _.includes(this.props.validations, "DIVISAO_OBRIGATORIA") &&
                                        <Validacao id="divisoesObrigatorias" valor={this.controller.divisoesValidacao}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "DEPARTAMENTO") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="departamentos">N4</Label>
                                    <Select id="departamentos"
                                            value={this.controller.filtro.departamentos}
                                            onChange={(value) => this.controller.setDepartamentos(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Todos"
                                            multi={true}
                                            options={[ ...this.controller.departamentos ]} />
                                    { _.includes(this.props.validations, "DEPARTAMENTO_OBRIGATORIO") &&
                                        <Validacao id="departamentosObrigatorios" valor={this.controller.departamentosValidacao}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "CARGO") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="cargos">Cargos</Label>
                                    <Select id="cargos"
                                            value={this.controller.filtro.cargos}
                                            onChange={(value) => this.controller.setCargos(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Todos"
                                            multi={true}
                                            options={[ ...this.controller.cargos ]} />
                                    { _.includes(this.props.validations, "CARGO_OBRIGATORIO") &&
                                        <Validacao id="cargosObrigatorios" valor={this.controller.cargosValidacao}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "EMPRESA") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="empresas">Unidades de negócio (BUs)</Label>
                                    <Select id="empresas"
                                            value={this.controller.filtro.empresas}
                                            onChange={(value) => this.controller.setEmpresas(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Todas"
                                            multi={true}
                                            options={[ ...this.controller.empresas ]} />
                                    { _.includes(this.props.validations, "EMPRESA_OBRIGATORIA") &&
                                        <Validacao id="empresasObrigatorias" valor={this.controller.empresasValidacao}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "SINDICATO") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="sindicatos">Sindicato</Label>
                                    <Select id="sindicatos"
                                            value={this.controller.filtro.sindicatos}
                                            onChange={(value) => this.controller.setSindicatos(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Todas"
                                            multi={true}
                                            options={[ ...this.controller.sindicatos ]} />
                                    { _.includes(this.props.validations, "SINDICATO_OBRIGATORIO") &&
                                        <Validacao id="sindicatosObrigatorios" valor={this.controller.sindicatosValidacao}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "FORNECEDOR") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="fornecedores">Fornecedores (ETT)</Label>
                                    <Select id="fornecedores"
                                            value={this.controller.filtro.fornecedores}
                                            onChange={(value) => this.controller.setFornecedores(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Todos"
                                            multi={true}
                                            options={[ ...this.controller.fornecedores ]} />
                                    { _.includes(this.props.validations, "FORNECEDOR_OBRIGATORIO") &&
                                        <Validacao id="fornecedoresObrigatorios" valor={this.controller.fornecedoresValidacao}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "PRODUTO") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="produtos">Projetos/centros de resultado/finalidades</Label>
                                    <Select id="produtos"
                                            value={this.controller.filtro.produtos}
                                            onChange={(value) => this.controller.setProdutos(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Todos"
                                            multi={true}
                                            options={[ ...this.controller.produtos ]} />
                                    { _.includes(this.props.validations, "PRODUTO_OBRIGATORIO") &&
                                        <Validacao id="produtosObrigatorios" valor={this.controller.produtosValidacao}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "COMPETENCIA_INICIO") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="competenciaInicio">Competência início</Label>
                                    <CustomDatePicker id="competenciaInicio"
                                        locale={"pt_BR"}
                                        className="form-control"
                                        dateFormat="DD/MM/YYYY"
                                        selectsStart
                                        startDate={this.controller.competenciaInicioSelecionada}
                                        endDate={this.controller.competenciaFimSelecionada}
                                        selected={this.controller.competenciaInicioSelecionada}
                                        onChange={(value) => this.controller.setCompetenciaInicio(value)}
                                        onBlur={(e) => this.controller.setCompetenciaInicioCheck(e.target.value)}
                                    />
                                    <Validacao id="competenciaInicio" valor={this.controller.competenciaInicioValidacao}
                                               tipo={["isDate","isRequired"]}/>
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "COMPETENCIA_FIM") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="competenciaFim">Competência fim</Label>
                                    <CustomDatePicker id="competenciaFim"
                                        locale={"pt_BR"}
                                        className="form-control"
                                        dateFormat="DD/MM/YYYY"
                                        selectsEnd
                                        startDate={this.controller.competenciaInicioSelecionada}
                                        endDate={this.controller.competenciaFimSelecionada}
                                        selected={this.controller.competenciaFimSelecionada}
                                        onChange={(value) => this.controller.setCompetenciaFim(value)}
                                        onBlur={(e) => this.controller.setCompetenciaFimCheck(e.target.value)}
                                    />
                                    <Validacao id="competenciaFim" valor={this.controller.competenciaFimValidacao}
                                               tipo={["isDate","isRequired",
                                                    "endDateSameOrAfter", this.controller.competenciaInicioValidacao,
                                                    "endDateMax12Months", this.controller.competenciaInicioValidacao
                                                ]}/>
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "COMPETENCIA_MES_INICIO") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="competenciaMesInicio">Competência início</Label>
                                    <MonthPicker id="competenciaMesInicio"
                                        value={this.controller.competenciaMesInicioSelecionada}
                                        onChange={(value) => this.controller.setCompetenciaMesInicio(value)}/>
                                    { _.includes(this.props.validations, "COMPETENCIA_MES_INICIO_OBRIGATORIA") &&
                                        <Validacao id="competenciaMesInicioObrigatoria" valor={this.controller.competenciaMesInicioSelecionada}
                                                tipo={["isRequiredMonthYearDate"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "COMPETENCIA_MES_FIM") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="competenciaMesFim">Competência fim</Label>
                                    <MonthPicker id="competenciaMesFim"
                                        value={this.controller.competenciaMesFimSelecionada}
                                        onChange={(value) => this.controller.setCompetenciaMesFim(value)}/>
                                    { !_.includes(this.props.validations, "DATA_FINAL_3_MESES") &&
                                        <Validacao id="competenciaMesFim" valor={this.controller.competenciaMesFimValidacao}
                                               tipo={[
                                                   "endDateSameOrAfter", this.controller.competenciaMesInicioValidacao,
                                                   "endDateMax12Months", this.controller.competenciaMesInicioValidacao
                                               ]}/>
                                    }
                                    { _.includes(this.props.validations, "COMPETENCIA_MES_FIM_OBRIGATORIA") &&
                                        <Validacao id="competenciaMesFimObrigatoria" valor={this.controller.competenciaMesFimSelecionada}
                                                tipo={["isRequiredMonthYearDate"]}/>
                                    }
                                    { _.includes(this.props.validations, "DATA_FINAL_3_MESES") &&
                                        <Validacao id="competenciaMesFim" valor={this.controller.competenciaMesFimValidacao}
                                               tipo={[
                                                   "endDateSameOrAfter", this.controller.competenciaMesInicioValidacao,
                                                   "endDateMax3Month", this.controller.competenciaMesInicioValidacao,
                                               ]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "AR_DEBITO") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="centrosCustoDebito">Centro custo débitos</Label>
                                    <Select id="centrosCustoDebito"
                                            value={this.controller.filtro.centrosCustoDebito}
                                            onChange={(value) => this.controller.setCentrosCustoDebito(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Todas"
                                            multi={true}
                                            options={[ ...this.controller.centrosCustoDebito ]} />
                                    { _.includes(this.props.validations, "AR_DEBITO_OBRIGATORIA") &&
                                        <Validacao id="centrosCustoDebitoObrigatorias" valor={this.controller.centrosCustoDebitoValidacao}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "SAZONALIDADE") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup check>
                                    <Label check>
                                        <br/><br/>
                                        <Input id="excluindoSazonalidade"
                                                type="checkbox"
                                                checked={this.controller.excluindoSazonalidadeSelecionada}
                                                onChange={() => this.controller.toggleExcluindoSazonalidade()}/>{" "}
                                        Excluindo sazonalidade
                                    </Label>
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "DATA_INICIAL") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="dataInicial">Data inicial</Label>
                                    <CustomDatePicker id="dataInicial"
                                        locale={"pt_BR"}
                                        className="form-control"
                                        dateFormat="DD/MM/YYYY"
                                        selectsStart
                                        startDate={this.controller.dataInicialSelecionada}
                                        endDate={this.controller.dataFinalSelecionada}
                                        selected={this.controller.dataInicialSelecionada}
                                        onChange={(value) => this.controller.setDataInicial(value)}
                                        onBlur={(e) => this.controller.setDataInicialCheck(e.target.value)}
                                    />
                                    <Validacao id="dataInicial" valor={this.controller.dataInicialValidacao}
                                               tipo={["isDate", "isRequired"]}/>
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "DATA_FINAL") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="dataFinal">Data final</Label>
                                    <CustomDatePicker id="dataFinal"
                                        locale={"pt_BR"}
                                        className="form-control"
                                        dateFormat="DD/MM/YYYY"
                                        selectsEnd
                                        startDate={this.controller.dataInicialSelecionada}
                                        endDate={this.controller.dataFinalSelecionada}
                                        selected={this.controller.dataFinalSelecionada}
                                        onChange={(value) => this.controller.setDataFinal(value)}
                                        onBlur={(e) => this.controller.setDataFinalCheck(e.target.value)}
                                    />
                                    { !_.includes(this.props.validations, "DATA_FINAL_1_MES") &&  !_.includes(this.props.validations, "DATA_FINAL_12_MESES") &&
                                    <Validacao id="dataFinal" valor={this.controller.dataFinalValidacao}
                                               tipo={["isDate", "isRequired"]}/>
                                    }
                                    { _.includes(this.props.validations, "DATA_FINAL_1_MES") &&
                                        <Validacao id="dataFinalObrigatoria" valor={this.controller.dataFinalValidacao}
                                                tipo={["isDate", "isRequired",
                                                    "endDateSameOrAfter", this.controller.dataInicialValidacao,
                                                    "endDateMax1Month", this.controller.dataInicialValidacao,
                                                ]}/>
                                    }
                                    { _.includes(this.props.validations, "DATA_FINAL_12_MESES") &&
                                        <Validacao id="dataFinalObrigatoria" valor={this.controller.dataFinalValidacao}
                                                tipo={["isDate", "isRequired",
                                                    "endDateSameOrAfter", this.controller.dataInicialValidacao,
                                                    "endDateMax12Months", this.controller.dataInicialValidacao,
                                                ]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "TIPO_FILTRO_REL_SOLICITACOES") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="tipoFiltroRelSolicitacoes">Tipo de filtro</Label>
                                    <Select id="tipoFiltroRelSolicitacoes"
                                            value={this.controller.filtro.tipoFiltroRelSolicitacoes}
                                            onChange={(value) => this.controller.setTipoFiltroRelSolicitacoes(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Solcitações no período"
                                            multi={false}
                                            options={[ ...this.controller.tipoFiltroRelSolicitacoes ]} />
                                    { _.includes(this.props.validations, "TIPO_FILTRO_REL_SOLICITACOES_OBRIGATORIA") &&
                                        <Validacao id="tipoFiltroRelSolicitacoesObrigatoria" valor={this.controller.tipoFiltroRelSolicitacoesValidacao}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "SITUACAO_SOLICITACAO") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="situacoesSolicitacao">Situações Solicitação</Label>
                                    <Select id="situacoesSolicitacao"
                                            value={this.controller.filtro.situacoesSolicitacao}
                                            onChange={(value) => this.controller.setSituacoesSolicitacao(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Todas"
                                            multi={true}
                                            options={[ ...this.controller.situacoesSolicitacao ]} />
                                    { _.includes(this.props.validations, "SITUACAO_SOLICITACAO_OBRIGATORIA") &&
                                        <Validacao id="situacoesSolicitacaoObrigatorias" valor={this.controller.situacoesSolicitacaoValidacao}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "JUSTIFICATIVA") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="justificativas">Justificativas</Label>
                                    <Select id="justificativas"
                                            value={this.controller.filtro.justificativas}
                                            onChange={(value) => this.controller.setJustificativas(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Todas"
                                            multi={true}
                                            options={[ ...this.controller.justificativas ]} />
                                    { _.includes(this.props.validations, "JUSTIFICATIVA_OBRIGATORIA") &&
                                        <Validacao id="justificativasObrigatorias" valor={this.controller.justificativasValidacao}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "COMPETENCIA_TERMINO_CONTRATO") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="competenciaTerminoContrato">Competência término contrato</Label>
                                    <MonthPicker id="competenciaTerminoContrato"
                                        value={this.controller.competenciaTerminoContratoSelecionada}
                                        onChange={(value) => this.controller.setCompetenciaTerminoContrato(value)}/>
                                    { _.includes(this.props.validations, "COMPETENCIA_TERMINO_CONTRATO_OBRIGATORIA") &&
                                        <Validacao id="competenciaTerminoContratoObrigatoria" valor={this.controller.competenciaTerminoContratoSelecionada}
                                                tipo={["isRequiredMonthYearDate"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "QUANTIDADE_ACESSO_CONSECUTIVO") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="quantidadeAcessoConsecutivo">Quantidade acesso consecutivo</Label>
                                    <Input id="quantidadeAcessoConsecutivo"
                                           type="number"
                                           min={0}
                                           value={this.controller.quantidadeAcessoConsecutivoSelecionada}
                                           onChange={(event) => this.controller.setQuantidadeAcessoConsecutivo(event.target.value)} />
                                    { _.includes(this.props.validations, "QUANTIDADE_ACESSO_CONSECUTIVO_OBRIGATORIA") &&
                                        <Validacao id="quantidadeAcessoConsecutivoObrigatoria" valor={this.controller.quantidadeAcessoConsecutivoSelecionada}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "QUANTIDADE_ACESSO_ALTERNADO") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="quantidadeAcessoAlternado">Quantidade acesso alternado</Label>
                                    <Input id="quantidadeAcessoAlternado"
                                           type="number"
                                           min={0}
                                           value={this.controller.quantidadeAcessoAlternadoSelecionada}
                                           onChange={(event) => this.controller.setQuantidadeAcessoAlternado(event.target.value)} />
                                    { _.includes(this.props.validations, "QUANTIDADE_ACESSO_ALTERNADO_OBRIGATORIA") &&
                                        <Validacao id="quantidadeAcessoAlternadoObrigatoria" valor={this.controller.quantidadeAcessoAlternadoSelecionada}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "CPF") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="cpf">CPF</Label>
                                    <NumberFormat id="cpf"
                                            className="form-control"
                                            format="###.###.###-##"
                                            value={this.controller.cpfSelecionado}
                                            onChange={(event, values) => this.controller.setCPF(values.value)}/>
                                    <Validacao id={"cpf"} valor={this.controller.cpfSelecionado} tipo={["isCPF"]} />
                                    { _.includes(this.props.validations, "CPF_OBRIGATORIO") &&
                                        <Validacao id="cpfObrigatorio" valor={this.controller.cpfSelecionado}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "MOT") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="mots">MOTs</Label>
                                    <Select id="mots"
                                            placeholder="Todos"
                                            searchingText="Pesquisando..."
                                            noResultsText="Nenhum resultado encontrado"
                                            searchPromptText="Informe nome para pesquisar"
                                            multi={true}
                                            value={this.controller.motsSelecionados}
                                            onChange={(value, options) => this.controller.setMOTs(value, options)}
                                            asyncOptions={(input, callback) => this.controller.filtrarMOTs(input, callback)} />
                                    { _.includes(this.props.validations, "MOT_OBRIGATORIO") &&
                                        <Validacao id="motsObrigatorios" valor={this.controller.motsSelecionados}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "COMPETENCIA") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="competencia">Competência</Label>
                                    <MonthPicker id="competencia"
                                        value={this.controller.competenciaSelecionada}
                                        onChange={(value) => this.controller.setCompetencia(value)}/>
                                    { _.includes(this.props.validations, "COMPETENCIA_OBRIGATORIA") &&
                                        <Validacao id="competenciaObrigatoria" valor={this.controller.competenciaSelecionada}
                                                tipo={["isRequiredMonthYearDate"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "NUMERO_LOTE") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="numeroLote">Número lote</Label>
                                    <Input id="numeroLote"
                                           type="number"
                                           min={0}
                                           value={this.controller.numeroLoteSelecionado}
                                           onChange={(event) => this.controller.setNumeroLote(event.target.value)} />
                                    { _.includes(this.props.validations, "NUMERO_LOTE_OBRIGATORIO") &&
                                        <Validacao id="numeroLoteObrigatorio" valor={this.controller.numeroLoteSelecionado}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "NUMERO_RC") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="numeroRC">Número RC</Label>
                                    <Input id="numeroRC"
                                           min={0}
                                           value={this.controller.numeroRCSelecionado}
                                           onChange={(event) => this.controller.setNumeroRC(event.target.value)} />
                                    { _.includes(this.props.validations, "NUMERO_RC_OBRIGATORIO") &&
                                        <Validacao id="numeroRCObrigatorio" valor={this.controller.numeroRCSelecionado}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "NUMERO_OC") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="numeroOC">Número OC</Label>
                                    <Input id="numeroOC"
                                           type="number"
                                           min={0}
                                           value={this.controller.numeroOCSelecionado}
                                           onChange={(event) => this.controller.setNumeroOC(event.target.value)} />
                                    { _.includes(this.props.validations, "NUMERO_OC_OBRIGATORIO") &&
                                        <Validacao id="numeroOCObrigatorio" valor={this.controller.numeroOCSelecionado}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "NUMERO_NF") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="numeroNF">Número NF</Label>
                                    <Input id="numeroNF"
                                           type="number"
                                           min={0}
                                           value={this.controller.numeroNFSelecionado}
                                           onChange={(event) => this.controller.setNumeroNF(event.target.value)} />
                                    { _.includes(this.props.validations, "NUMERO_NF_OBRIGATORIO") &&
                                        <Validacao id="numeroNFObrigatorio" valor={this.controller.numeroNFSelecionado}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                        { _.includes(this.props.fields, "SITUACAO_TIMESHEET") &&
                            <Col xs={12} md={6} lg={3}>
                                <FormGroup>
                                    <Label for="situacoesTimesheet">Situações timesheet</Label>
                                    <Select id="situacoesTimesheet"
                                            value={this.controller.filtro.situacoesTimesheet}
                                            onChange={(value) => this.controller.setSituacoesTimesheet(value)}
                                            noResultsText="Nenhum resultado encontrado"
                                            placeholder="Todas"
                                            multi={true}
                                            options={[ ...this.controller.situacoesTimesheet ]} />
                                    { _.includes(this.props.validations, "SITUACAO_TIMESHEET_OBRIGATORIA") &&
                                        <Validacao id="situacoesTimesheetObrigatorias" valor={this.controller.situacoesTimesheetValidacao}
                                                tipo={["isRequired"]}/>
                                    }
                                </FormGroup>
                            </Col>
                        }
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12}>
                            { this.props.onSubmit &&
                                <Button color="primary" type="submit">Filtrar</Button>
                            }
                            {" "}
                            { (this.props.onExportExcel || this.props.onExportPdf) &&
                                <ButtonDropdown isOpen={this.controller.exportOpen} toggle={() => this.controller.toggleExport()}>
                                    <DropdownToggle caret>
                                        Exportar
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        { this.props.onExportExcel &&
                                            <DropdownItem onClick={() => this.onExportExcel()}>Excel</DropdownItem>
                                        }
                                        { this.props.onExportPdf &&
                                            <DropdownItem onClick={() => this.onExportPdf()}>PDF</DropdownItem>
                                        }
                                    </DropdownMenu>
                                </ButtonDropdown>
                            }
                            {" "}
                            <Button onClick={() => this.onClear()}>Limpar</Button>
                        </Col>
                    </Row>
                </form>
            </div>
        );
    }
}
